
import { useParams } from "react-router-dom";
import { useFundData } from "@/hooks/useFundData";
import { FundProfileLayout } from "@/components/fund/components/FundProfileLayout";
import { FundProfileSkeleton } from "@/components/fund/components/FundProfileSkeleton";
import { FundProfileError } from "@/components/fund/components/FundProfileError";
import { FundProfileContent } from "@/components/fund/components/FundProfileContent";
import { useEffect } from "react";

const FundProfile = () => {
  const { fundId } = useParams();
  const { data: fund, isLoading } = useFundData(fundId);

  // Scroll to top when component mounts or fundId changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [fundId]);

  if (isLoading) {
    return (
      <FundProfileLayout>
        <FundProfileSkeleton />
      </FundProfileLayout>
    );
  }

  if (!fund) {
    return (
      <FundProfileLayout>
        <FundProfileError />
      </FundProfileLayout>
    );
  }

  return (
    <FundProfileLayout>
      <FundProfileContent fund={fund} />
    </FundProfileLayout>
  );
};

export default FundProfile;
